<template>
  <ProductTitle v-bind="{ productName, description, brandUrl, brandDisplayName, pdfEmailDescription }" />
</template>

<script setup>
import { computed } from 'vue';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';
import { useConsolidatedProductDetails } from '@composables/useConsolidatedProductDetails';
import ProductTitle from './ProductTitle';

const { productName: consolidatedName } = useConsolidatedProductDetails();
const {
  productName: nameRaw, brandDisplayName, brandUrl: brandUrlRaw, secondaryDescription: description, pdfEmailDescription,
} = useCommonProductGetters();

const productName = computed(() => consolidatedName.value || nameRaw.value);

const brandUrl = computed(() => brandDisplayName.value && brandUrlRaw.value);
</script>
